<script setup lang="ts">
import { EvmInternalTrxInfo, EvmTrxDetailInfo } from '~/api/repository'
import { capitalizeFirstLetter } from '~/utils/stringFormat'

interface IProps {
  // 'SUCCESS' | 'PENDING' | 'FAILURE' | 'OUT_COMING' | 'IN_COMING' | 'ALL';
  status: EvmInternalTrxInfo['STP'] | EvmTrxDetailInfo.STATTP
  abbreviation?: boolean
}

const colorMap = {
  SUCCESS: 'bg-explorer-teal',
  PENDING: 'bg-explorer-yellow',
  FAILURE: 'bg-explorer-rose',
}

defineProps<IProps>()

</script>

<template>
  <span class="transaction-status-container">
    <template v-if="abbreviation">
      <span
        class="abbreviation"
        :class="colorMap[status]"
      />
    </template>
    <template v-else>
      <span
        class="status-chip"
        :class="colorMap[status]"
      >{{ capitalizeFirstLetter(status) }}</span>
    </template>
  </span>
</template>

<style scoped lang="scss">
.transaction-status-container {
  @apply flex items-center;

  .abbreviation {
    @apply inline-block w-2 h-2 rounded-full;
  }

  .status-chip {
    @apply inline-block rounded-full px-2 py-0.5 text-white text-base font-bold;

    // pending badge
    &.bg-explorer-yellow {
      @apply relative overflow-hidden;

      &::after {
        @apply absolute -top-full left-0 opacity-40;
        content: '';
        background-image: linear-gradient(90deg, transparent, white 50%, transparent);
        width: 100%;
        height: 300%;
        animation: shine 2s ease-in-out infinite;
        @keyframes shine {
          from {
            left: -120%;
          }
          to {
            left: 120%;
          }
        }
      }
    }
  }
}

</style>